// Lucide icon: ellipsis (https://lucide.dev/icons/ellipsis)
import { Ellipsis } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMore = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Ellipsis />
    </IconComponentStyled>
  )
}
